import { ReactElement, useEffect, useState } from 'react';
import { Outlet, matchPath, useNavigate } from 'react-router-dom';

import ChatBotPopup from 'components/ChatBot';
import { useCompanyDetails } from 'components/Dialogs/hooks';
import { TopMenu } from 'components/TopMenu';
import { BREAKPOINTS } from 'constants/index';
import { NavigationBar } from 'features/navigation';
import { useSubscription, useWindowSize } from 'hooks';
import { Links } from 'settings';

import { PageContentW, PageW } from './styled';

export function AppLayout(): ReactElement {
  const [companyId, setCompanyId] = useState<string>('');

  const navigate = useNavigate();

  const { width } = useWindowSize();

  const { isExpired } = useSubscription();

  const { company } = useCompanyDetails();

  useEffect(() => {
    if (company?.id) {
      setCompanyId(company.id);
    }
  }, [company?.id]);

  const arrOfLinks = [
    Links.actions.employeesInvite,
    Links.we.employees.invite,
    Links.resources.employees.invite,
    Links.profile.extended.extended,
    Links.we.employees.employee.createDocument,
    Links.actions.createDocument,
    Links.actions.createNotification,
    Links.resources.createCategory,
    Links.resources.edit.categoryId,
    Links.resources.documents.edit.documentId,
    Links.posts.edit.postId,
    Links.resources.createDocument,
    Links.resources.createTaggedDocument.tagged.tag,
    Links.profile.createDocument,
    Links.profile.privateDocuments.edit.documentId,
    Links.we.createTask,
    Links.actions.createTask,
    Links.profile.createTask,
    Links.we.taskManagement.taskDetails,
    Links.profile.taskManagement.taskDetails,
    Links.profile.taskManagement.index,
    Links.we.taskManagement.index,
    Links.actions.createPost,
    Links.we.createPost,
    Links.profile.equipmentList.equipment.index,
    Links.profile.equipmentList.createEquipment,
    Links.actions.createEquipment,
    Links.profile.equipmentList.equipment.equipmentId.index,
    Links.profile.equipmentList.equipment.equipmentId.attachments,
    Links.actions.createPoll,
    Links.we.createPoll,
    Links.profile.achievements.createAchievement,
    Links.profile.achievements.achievement.achievementId.index,
    Links.profile.achievements.achievement.achievementId.createGoal,
    Links.profile.achievements.achievement.achievementId.goal.goalId,
    Links.profile.achievements.achievement.index,
  ];

  const showChatBot = [
    'dc2e290d-1994-49be-8092-4284e6c669bf',
    'c39e4010-2e95-40a1-bfae-b53f303d5c0a',
    'edd47e7a-e997-4ff8-a63e-5f050f204869',
    // '149fb71d-4a84-4599-9df0-ee4d2d47ca4c',
    '7004f527-3db9-4972-9fc2-a93357e19b57',
  ].includes(company?.id || '');

  const isNavbarHidden =
    width <= BREAKPOINTS.web &&
    arrOfLinks.some((route) => !!matchPath(route, window.location.pathname));

  useEffect(() => {
    if (isExpired) {
      navigate(Links.actions.subscriptions);
    }
  }, [isExpired, navigate]);

  return (
    <PageW>
      <TopMenu />
      <NavigationBar />

      <PageContentW sx={isNavbarHidden ? { marginBottom: 'auto' } : {}} id="main-page">
        <Outlet />
        {showChatBot && <ChatBotPopup companyId={companyId} />}
      </PageContentW>
    </PageW>
  );
}
